/** @jsx h */
// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';
import PropType from 'prop-types';

import { isActiveLink } from '../../utils';

import { navigationItemPropType } from '../../propTypes';

import { Link } from './styles';

const SecondaryNavigationItem = ({ item, sitePrimaryColor, alternate }) => {
  const current = navigationItem => (isActiveLink(navigationItem.link) ? 'page' : 'false');
  return (
    <Link
      aria-current={current(item)}
      primaryColor={sitePrimaryColor}
      item={item}
      href={item.link}
      active={isActiveLink(item.link)}
      alternate={alternate}
    >
      {item.title}
    </Link>
  );
};

SecondaryNavigationItem.propTypes = {
  item: navigationItemPropType,
  sitePrimaryColor: PropType.string,
  alternate: PropType.bool,
};

SecondaryNavigationItem.defaultProps = {
  item: null,
  sitePrimaryColor: null,
  alternate: false,
};

export default SecondaryNavigationItem;
